// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabNavLink_tab__2RMLh","selected":"TabNavLink_selected__Yo4yq"};